import { render, staticRenderFns } from "./SidebarElement.vue?vue&type=template&id=664f39fa"
import script from "./SidebarElement.vue?vue&type=script&lang=js"
export * from "./SidebarElement.vue?vue&type=script&lang=js"
import style0 from "./SidebarElement.vue?vue&type=style&index=0&id=664f39fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports